import React from 'react';
import { Routes, Route, useLocation, Link } from 'react-router-dom';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import GitLabProjects from './components/GitLabProjects';
import VpcProjectPage from './pages/VpcProjectPage';
import CICDPipeline from './pages/CICDPipeline';
import ScrollToTop from './components/ScrollToTop';
import ScrollToHash from './components/ScrollToHash';

function App() {
  const location = useLocation();

  return (
    <div className="min-h-screen w-full bg-slate-900 text-white font-sans scroll-smooth">
      <ScrollToTop />
      <ScrollToHash />

      {/* Navigation Bar */}
      <nav className="fixed top-0 left-0 right-0 bg-slate-800 z-50 shadow-md p-4 flex justify-between items-center">
        <div className="text-2xl font-bold text-blue-400">Ravi</div>
        <ul className="flex space-x-6 text-sm font-medium">
          <li><Link to="/#hero">Home</Link></li>
          <li><Link to="/#about">About</Link></li>
          <li><Link to="/#skills">Skills</Link></li>
          <li><Link to="/#projects">Projects</Link></li>
          <li><Link to="/#gitlab-projects">Own Projects</Link></li>
          <li><Link to="/#experience">Experience</Link></li>
          <li><Link to="/#contact">Contact</Link></li>
        </ul>
      </nav>

      {/* Page Content */}
      <main className="pt-20 space-y-20">
        <Routes location={location}>
          <Route path="/" element={
            <>
              <section id="hero" className="scroll-mt-24"><Hero /></section>
              <section id="about" className="scroll-mt-24"><About /></section>
              <section id="skills" className="scroll-mt-24"><Skills /></section>
              <section id="projects" className="scroll-mt-24"><Projects /></section>
              <section id="gitlab-projects" className="scroll-mt-24"><GitLabProjects /></section>
              <section id="experience" className="scroll-mt-24"><Experience /></section>
              <section id="contact" className="scroll-mt-24"><Contact /></section>
            </>
          } />
          <Route path="/vpc-project" element={<VpcProjectPage />} />
          <Route path="/ci-cd-pipeline" element={<CICDPipeline />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
